import { render } from "./BaseDialog.vue?vue&type=template&id=4e210cda&scoped=true&ts=true"
import script from "./BaseDialog.vue?vue&type=script&lang=ts"
export * from "./BaseDialog.vue?vue&type=script&lang=ts"

import "./BaseDialog.vue?vue&type=style&index=0&id=4e210cda&scoped=true&lang=css"

import exportComponent from "/Users/aleksandrvasilevic/Documents/Dev/WEB/Pets/phone-book/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e210cda"]])

export default __exports__